import { CkeditorConstants } from "./ckeditorconstants";
import { CKEditor5 } from "../ckeditor";

const {
  htmlAttributes: { CLASS },
  class: { REF }
} = CkeditorConstants;

/**
 * Check the element is link and selected whole
 * @param { CKEditor5 } editor
 */
export const checkForSelectedLinkId = (editor) => {
  const { model: { document: { selection } } } = editor;
  let selectedValues = []
  for (const value of selection.getRanges()) {
    for (const itemInSelection of value.getWalker()) {
      if (itemInSelection.item?.textNode?.parent.hasAttribute(CLASS) && itemInSelection.item?.textNode?.parent.getAttribute(CLASS) === REF) {
        selectedValues.push(itemInSelection.item.data === itemInSelection.item.textNode.data ? itemInSelection.item.textNode.parent.getAttribute('id') : ''); // to check whole link is selected or not
      }
    }
  }
  return selectedValues;
}

/**
 * Check if the selection is insertion or not
 * @param { CKEditor5 } editor
 */
export const checkIfSelectionIsInsertion = (editor) => {
  let isTextMarkedInGreen = false;
  const range = editor.model.document.selection.getFirstRange();
  const markers = [...editor.model.markers.getMarkersIntersectingRange(range)];
  markers.forEach(marker => {
    if (marker.name.split(':')[1] === 'insertion') {
      isTextMarkedInGreen = true;
    }
  })
  return isTextMarkedInGreen;
}

export const isLinkElement = (element) => {
  return element?.getAttribute?.(CkeditorConstants.htmlAttributes.REL) === CkeditorConstants.linksTo;
};

const isLinkTextNode = (node) => {
  return node?.parent?.getAttribute?.(CkeditorConstants.htmlAttributes.CLASS) === REF ||
    node?.parent?.getAttribute?.(CkeditorConstants.helperAttributes.REL) === CkeditorConstants.linksTo ||
    node?.hasAttribute?.(CkeditorConstants.helperAttributes.LINK_HREF);
};

/**
 * Returns the first link-related text node found in the current selection.
 * It supports both refreshed link wrappers and fresh linkHref text nodes.
 * @param { CKEditor5 } editor
 * @returns { any }
 */
export const getLinkTextNodeInSelection = (editor) => {
  const { model: { document: { selection } } } = editor;

  const textNodeFromWalker = [...selection.getRanges()]
    .flatMap((range) => [...range.getWalker({ ignoreElementEnd: true })])
    .map((itemInSelection) => itemInSelection?.item?.textNode || itemInSelection?.item)
    .find((node) => isLinkTextNode(node));

  const focus = selection.focus;
  const textNodeNearCursor = focus?.textNode || focus?.nodeBefore || focus?.nodeAfter || null;
  const isTextNodeNearCursorLink = isLinkTextNode(textNodeNearCursor);

  return textNodeFromWalker || (isTextNodeNearCursorLink ? textNodeNearCursor : null);
};

export const findLinkOrCitationElement = (element) => {
  if (element.name == 'numberedcitation') {
    return element.name
  } else if (isLinkElement(element)) {
    return 'link'
  }
}
